import { IGioCongDong } from "../models/response/gio-cong-dong/IGioCongDong";
import { apiClient } from "./apiClient";

export const gioCongDongApi = {
    load: () => apiClient.get(`gio-cong-dong`),
    insert: (payload: IGioCongDong) => apiClient.post(`gio-cong-dong`, payload),
    update: (payload: IGioCongDong) => apiClient.put(`gio-cong-dong`, payload),
    delete: (id: number) => apiClient.delete(`gio-cong-dong/${id}`),
}